export const isMobile = () => {
  return (
    navigator.maxTouchPoints > 0 && /android|iphone/i.test(navigator.userAgent)
  );
};

export const isTouchScreenNoteBook = () => {
  return (
    navigator.maxTouchPoints > 0 && !/android|iphone/i.test(navigator.userAgent)
  );
};
